// Tonal chip + status chip. Ported from botriq-admin-fe's Robot Portal UI kit.
import PropTypes from "prop-types";

const TONE_MAP = {
  accent: ["var(--bq-accentSoft)", "var(--bq-accent)"],
  success: ["var(--bq-successSoft)", "var(--bq-success)"],
  warning: ["var(--bq-warningSoft)", "var(--bq-warning)"],
  danger: ["var(--bq-dangerSoft)", "var(--bq-danger)"],
  muted: ["var(--bq-surface3)", "var(--bq-text2)"],
};

export const Chip = ({ label, tone = "muted", dot, pulse, style }) => {
  const [bg, fg] = TONE_MAP[tone] || TONE_MAP.muted;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        padding: "3px 8px",
        borderRadius: 6,
        fontSize: 11,
        fontWeight: 600,
        lineHeight: 1.3,
        background: bg,
        color: fg,
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {dot && (
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            background: dot,
            ...(pulse ? { animation: "rp-pulse 1.6s ease-in-out infinite" } : {}),
          }}
        />
      )}
      {label}
    </span>
  );
};

Chip.propTypes = {
  label: PropTypes.node,
  tone: PropTypes.string,
  dot: PropTypes.string,
  pulse: PropTypes.bool,
  style: PropTypes.object,
};

// Robot status → chip. Central place so every screen renders status identically.
export const STATUS_META = {
  delivering: { label: "Delivering", tone: "accent", dot: "var(--bq-accent)", pulse: true },
  online: { label: "Online", tone: "success", dot: "var(--bq-success)" },
  active: { label: "Active", tone: "success", dot: "var(--bq-success)" },
  charging: { label: "Charging", tone: "warning", dot: "var(--bq-warning)" },
  idle: { label: "Idle", tone: "warning", dot: "var(--bq-warning)" },
  offline: { label: "Offline", tone: "muted", dot: "var(--bq-text3)" },
  error: { label: "Error", tone: "danger", dot: "var(--bq-danger)", pulse: true },
};

// Charging is a SEPARATE axis from status — a robot is idle AND charging — so it
// is passed alongside rather than folded into `status` by every caller.
export const resolveStatus = (status, charging) => {
  if (status === "error") return "error";
  return charging ? "charging" : status;
};

export const StatusChip = ({ status, charging = false }) => {
  const m = STATUS_META[resolveStatus(status, charging)] || STATUS_META.offline;
  return <Chip label={m.label} tone={m.tone} dot={m.dot} pulse={m.pulse} />;
};

StatusChip.propTypes = { status: PropTypes.string, charging: PropTypes.bool };

export default Chip;
